import React from "react"
import { ILinkFunc } from "../../lib/util";
import Heading from "./Heading";
import { Button } from "../Button/Button";


export enum EVideoPosition {
    right = "right",
    left = "left"
}

export interface ITextVideoPairBladeProps {
    wrapperClassName?: string;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    titleClassName?: string;
    subtitle?: string;
    headingCTA?: { href: string; text: string; target?: string; }
    colsWrapperClassName?: string;
    textColTitle?: string;
    textColText?: string;
    textColCTA?: { href: string; text: string; target?: string; }
    video?: { url: string; }
    videoPosition: EVideoPosition;
    linkFunc?: ILinkFunc;
    videoPoster?: string;
}

export const TextVideoPairBlade: React.FC<ITextVideoPairBladeProps> = ({
    wrapperClassName = "",
    title,
    titleClassName,
    titleHeadingLevel = "h2",
    headingCTA,
    colsWrapperClassName = "",
    textColTitle,
    textColText,
    textColCTA,
    video,
    videoPosition = EVideoPosition.right,
    linkFunc,
    videoPoster,
}) => {

    const linkf = linkFunc || ((props) => <a {...props} />);

    let titleLayout = "text-center"
    if (headingCTA?.href) {
        titleLayout = "flex flex-row justify-between"
    }

    let videoUrl = video?.url;
    if (!videoPoster) {
        videoUrl = `${video?.url}#t=0.001`
    }

    return (
        <section className={`text-video-pair-blade relative w-full max-w-screen-2xl mx-auto ${wrapperClassName}`}>
            <Heading headingLevel={titleHeadingLevel} className={`${titleLayout} md:col-span-3 ${titleClassName}`}>
                {title}
                {headingCTA?.href && (
                    <Button
                        linkFunc={linkf}
                        linkProps={{
                            className: "block",
                            href: headingCTA.href,
                            target: headingCTA.target
                        }}
                    >
                        {headingCTA.text}
                    </Button>
                )}
            </Heading>
            <div className={`w-full mx-auto flex flex-wrap lg:flex-nowrap px-2 gap-10 ${colsWrapperClassName}`}>
                <div className="w-full lg:w-1/2 max-w-screen-md lg:max-w-screen-full flex flex-col items-start gap-2">
                    {textColTitle && <span className="block text-xl w-full">{textColTitle}</span>}
                    {textColText && <div className="w-full" dangerouslySetInnerHTML={{ __html: textColText }}></div>}
                    {textColCTA?.href && (
                        <Button
                            linkFunc={linkf}
                            linkProps={{
                                className: "inline-block",
                                href: textColCTA.href,
                                target: textColCTA.target
                            }}
                        >
                            {textColCTA.text}
                        </Button>
                    )}
                </div>
                <div className={`w-full lg:w-1/2 max-w-screen-md lg:max-w-screen-full ${videoPosition === EVideoPosition.left ? "order-first" : ""}`}>
                    {video?.url && <video
                        className="w-full aspect-[16/9]"
                        controls
                        playsInline
                        src={videoUrl}
                        poster={videoPoster}
                    ></video>}
                </div>
            </div>
        </section>
    )
}